module.exports = __webpack_public_path__ + "static/media/ic_notif_reject.93deb665.svg";